// api calls
import {adminWrappingApi as api} from '../../../api/admin/WrappingManagement'

// state -> info about way of storing data; https://forum.vuejs.org/t/vuex-best-practices-for-complex-objects/10143/2
const state = {
    objects: [],
    objectsList: [],
}

// getters
const getters = {
    all:                    state => state.objectList.map(id => state.objects[id]),
    getById:                (state) => (id) => {
        return state.objects[id]
    },
}

// actions
const actions = {
    setWrappings ({commit}, payload) {
        // The server post should be handled by g-form
        commit('set', {
            objects: payload
        })
    },

    findWrapping ({ commit }, query) {
        return new Promise((resolve, reject) => {
            api.findWrapping(query).then(({ data }) => {
                resolve(data)
            })
        })
    },

    add ({commit}, payload) {
        // The server post should be handled by g-form
        commit('add', payload)
    },

    update ({commit}, payload) {
        // The server patch should be handled by g-form
        commit('update', payload)
    },
}

// mutations
const mutations = {
    set (state, payload) {
        let wrappings = payload.objects.map((wrapping) => {
            const connected_to = wrapping.connected_to.map((company) => {
                return {
                    id: company.id,
                    label: company.name
                }
            })

            return {
                ...wrapping,
                connected_to:   connected_to
            }
        })

        state.objects    = wrappings.reduce((obj, object) => {
            obj[object.id] = object

            return obj
        }, {})

        state.objectList = wrappings.map(object => object.id)
    },

    add (state, payload) {
        state.objects[payload.object.id] = payload.object
        state.objectList.push(payload.object.id)
    },

    update (state, payload) {
        if (typeof payload.object.connected_to !== 'undefined' && payload.object.connected_to.length >= 1) {
            payload.object['connected_to'] = payload.object.connected_to.map((company) => {
                return {
                    id: company.id,
                    label: company.name
                }
            })
        }

        state.objects[payload.object.id] = payload.object
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
